import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import i18n from './lang/config'
import helper from './mixins/index'
import VueCookie from 'vue-cookie'
import vuetify from './plugins/vuetify'
import eventBus from './plugins/events'
import formatter from './plugins/formatters'
import apiServices from './plugins/apiservices'
import projectChatRt from './plugins/project_chat_realtime'
import axios from 'axios'
import VueSignaturePad from 'vue-signature-pad'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import Sortable from 'sortablejs'
import VueCryptojs from 'vue-cryptojs'
import { replaceDotWithComma, replaceCommaWithDot, filterDate, filterDateTime, absoluteNumber } from './assets/js/filters'
import './registerServiceWorker'
import './assets/css/theme-dark.css'
import exportingInit from 'highcharts/modules/exporting'
import * as Sentry from '@sentry/vue'
exportingInit(Highcharts)

Vue.config.productionTip = false

/* Filters */
const filters = {
  dateFormat: filterDate,
  dateTimeFormat: filterDateTime,
  replaceDotWithComma,
  replaceCommaWithDot,
  absoluteNumber
}
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const plugins = { formatter, VueCookie, eventBus, apiServices, VueCryptojs, projectChatRt }
Object.keys(plugins).forEach(key => {
  Vue.use(plugins[key])
})
Vue.use(VueSignaturePad)

const mixins = { helper }
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
})
Vue.use(VueHighcharts, { Highcharts })
axios.defaults.baseURL = process.env.VUE_APP_URL
axios.defaults.headers.Authorization = `Bearer ${VueCookie.get(process.env.VUE_APP_TOKEN)}`
Vue.directive('sortable', {
  inserted: function (el, binding) {
    // eslint-disable-next-line
    new Sortable(el, binding.value || {})
  }
})
Sentry.init({
  Vue,
  dsn: 'https://f55f00b937bd0f04ac606755d199cdde@o4507413689532416.ingest.de.sentry.io/4507509865119824',
  environment: process.env.VUE_APP_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({ levels: ['debug'] })
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [process.env.VUE_APP_API_URL, /^\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // axios "Request aborted" = the browser cancelled an in-flight request
  // (page change, app backgrounded, screen off on Android). Not a bug, and
  // any caller without its own .catch() turned it into an "unhandled" Sentry
  // error. Real API failures (4xx/5xx, "Network Error") are still reported.
  ignoreErrors: ['Request aborted']
})
new Vue({
  router,
  store,
  i18n,
  vuetify,
  eventBus,
  render: h => h(App)
}).$mount('#app')
